import type { WidgetConfig } from './widgetConfig'

type ThemeKV = Record<string, string | undefined>

function trimOrEmpty(v: unknown): string {
    return typeof v === 'string' ? v.trim() : ''
}

export function applyWidgetTheme(rootEl: Element, cfg: Partial<WidgetConfig>) {
    const el = rootEl as HTMLElement
    el.classList.add('pfe-widget-root')

    const vars: ThemeKV = {
        '--pfe-font-family': trimOrEmpty(cfg.fontFamily),
        '--pfe-font-size-base': trimOrEmpty(cfg.fontSizeBase),
        '--pfe-color-text': trimOrEmpty(cfg.textColor),
        '--pfe-color-muted': trimOrEmpty(cfg.mutedColor),
        '--pfe-color-accent': trimOrEmpty(cfg.accentColor),
        '--pfe-color-bg': trimOrEmpty(cfg.backgroundColor),
        '--pfe-color-border': trimOrEmpty(cfg.borderColor),
    }

    for (const [k, v] of Object.entries(vars)) {
        if (v) el.style.setProperty(k, v)
    }
}
